import React, { useEffect, useState } from 'react';

// narrow red bar that indicates content is being loaded.
import { jsx as _jsx } from "react/jsx-runtime";
export const LoadingBarStateContext = /*#__PURE__*/React.createContext(false);
const LoadingBarDispatchContext = /*#__PURE__*/React.createContext(undefined);
export const LoadingBarProvider = ({
  children
}) => {
  const [isLoading, setLoading] = useState(false);
  return /*#__PURE__*/_jsx(LoadingBarStateContext.Provider, {
    value: isLoading,
    children: /*#__PURE__*/_jsx(LoadingBarDispatchContext.Provider, {
      value: setLoading,
      children: children
    })
  });
};
export const useLoadingBarState = () => {
  const context = React.useContext(LoadingBarStateContext);
  if (context === undefined) {
    throw new Error('useLoadingBarState must be used within a LoadingBarProvider');
  }
  return context;
};
const useLoadingBarDispatch = () => {
  const context = React.useContext(LoadingBarDispatchContext);
  if (context === undefined) {
    throw new Error('useLoadingBarDispatch must be used within a LoadingBarProvider');
  }
  return context;
};
export const useLoadingBar = isLoading => {
  const setLoading = useLoadingBarDispatch();
  useEffect(() => {
    setLoading(isLoading);
    return () => setLoading(false);
  }, [isLoading, setLoading]);
};